// extracted by mini-css-extract-plugin
export default {"btnMainColor":"MainColorBtn_btnMainColor__n69pn"};